import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Spinner} from "office-ui-fabric-react";
import * as microsoftTeams from "@microsoft/teams-js";
import {post} from "../api";
import AuthenticateUser from "./AuthenticateUser";
import {DmsCaseInfo} from "../models";
import {AppInsightsLoggingForTeams, InitialiseAppInsights} from "./ApplicationInsights";
import {ApplicationInfo} from "./AppInfo";

export interface IStorePostState extends ITeamsBaseComponentState {
    teamGroupId: string;
    userId: string;
    channelId: string;
    tenantId: string;
    loading: boolean;
    error: string;
    caseInfo: DmsCaseInfo | null;
    teamsTheme: string;
}

export interface IStorePostProps {}

export class StorePost extends TeamsBaseComponent<IStorePostProps, IStorePostState> {
    constructor(props: IStorePostProps) {
        super(props);
        this.state = {
            teamGroupId: this.getQueryVariable("teamsId"),
            userId: this.getQueryVariable("userId"),
            channelId: this.getQueryVariable("channelId"),
            tenantId: this.getQueryVariable("tenantId"),
            theme: null,
            loading: true,
            error: "",
            caseInfo: null,
            teamsTheme: "default",
        };
        const appInsights = InitialiseAppInsights(ApplicationInfo);
        AppInsightsLoggingForTeams(
            ApplicationInfo,
            appInsights,
            this.state.tenantId,
            this.state.teamGroupId,
            this.state.userId
        );
    }

    public async componentWillMount(): Promise<void> {
        microsoftTeams.initialize(() => {
            microsoftTeams.getContext(
                function (context: {theme: string; teamName: string}) {
                    this.setState({teamsTheme: context.theme, teamName: context.teamName});
                }.bind(this)
            );
        });
    }

    public async componentDidMount() {
        microsoftTeams.registerOnThemeChangeHandler(
            function (theme: string) {
                this.setState({teamsTheme: theme});
            }.bind(this)
        );
    }

    public async componentDidUpdate(prevProps: IStorePostProps, prevState: IStorePostState) {
        if (!prevState.caseInfo && this.state.caseInfo) {
            await this.storePost();
        }
    }

    public render() {
        if (this.state.teamGroupId == "{groupId}") {
            // teamsid will be the placeholder if invoked from a non Team
            return (
                <div className="center" style={{color: "red"}}>
                    Store posts is only available for Teams posts with linked matters
                </div>
            );
        }

        if (!this.state.caseInfo) {
            return (
                <AuthenticateUser
                    tenantId={this.state.tenantId}
                    userId={this.state.userId}
                    teamGroupId={this.state.teamGroupId}
                    channelId={this.state.channelId}
                    AuthenticatedWithCase={this.isAuthenticatedWithCase.bind(this)}
                />
            );
        }
        if (this.state.loading) {
            return (
                <div>
                    <Spinner />
                    <div style={{color: this.state.teamsTheme !== "default" ? "white" : "black"}}>
                        Saving Post as PDF
                    </div>
                </div>
            );
        }

        if (!this.state.error) {
            return (
                <div className="center" style={{color: this.state.teamsTheme !== "default" ? "white" : "black"}}>
                    Stored post as PDF
                    <br />
                    You can now close this window.
                </div>
            );
        }
        return (
            <div className="center" style={{color: "red"}}>
                Failed to store post as PDF
                <br />
                {this.state.error}
                <br />
                Close this window to continue.
            </div>
        );
    }

    private storePost = async () => {
        await post("/api/teamsdmsintegration/StorePost" + window.location.search, "")
            .then((response) => {
                if (response.ok) return response.json();
                this.setState({loading: false, error: response.statusText});
            })
            .then((response) => {
                const storedPost = response.StoredPost as boolean;
                let errorJson = response.Error as string;

                if (errorJson !== null && errorJson.includes("InvalidPermissions")) {
                    errorJson = "Invalid permissions or destination location has been removed.";
                }
                const errorMessage = errorJson ? errorJson : !storedPost ? "Failed to store post." : null;

                this.setState({loading: false, error: errorMessage});
            });
    };

    private isAuthenticatedWithCase(_storageType: string, caseInfo: DmsCaseInfo) {
        this.setState({caseInfo});
    }
}
